
import { APIS } from "../../../_config";
import { CallApi } from "../callApi";

export interface AppellationFormData {
  name: string;
  country_id: string;
  region_id: string;
  sub_region_id: string;
}

export interface Appellation {
  id: string;
  name: string;
  country_id: string;
  region_id: string;
  sub_region_id: string;
  country: {
    name: string;
    id: string;
  };
  region: {
    name: string;
    region_code: string;
    id: string;
  };
  created_at: string;
  updated_at: string;
}

export interface Region {
  id: string;
  name: string;
  region_code: string;
}

export function useAppellationApi() {
  // List appellations
  const getAppellationList = async (params: any = {}): Promise<any> => {
    const response = await CallApi.GET(APIS.LOCATION_SETTINGS.APPELLATION.APPELLATIONS, params, true);
    return response;
  };

  // Get single Appellation by ID
  const getAppellationById = async (id: string): Promise<any> => {
    const response = await CallApi.GET(APIS.LOCATION_SETTINGS.APPELLATION.DETAIL(id), {}, true);
    return response;
  };

  // Create Appellation
  const createAppellation = async (data: AppellationFormData): Promise<any> => {
    const response = await CallApi.POST(APIS.LOCATION_SETTINGS.APPELLATION.APPELLATIONS, data, true);
    return response;
  };

  // Update Appellation
  const updateAppellation = async (id: string, data: AppellationFormData): Promise<any> => {
    const response = await CallApi.PUT(APIS.LOCATION_SETTINGS.APPELLATION.DETAIL(id), data, true);
    return response;
  };

  // Delete Appellation
  const deleteAppellation = async (id: string): Promise<any> => {
    const response = await CallApi.DELETE(APIS.LOCATION_SETTINGS.APPELLATION.DETAIL(id), true);
    return response;
  };

  // Get Appellation Tree
  const getAppellationTree = async (params : any = {}): Promise<any> => {
    const response = await CallApi.GET(APIS.LOCATION_SETTINGS.APPELLATION.TREE, params, true);
    return response;
  };

  return {
    getAppellationList,
    getAppellationById,
    createAppellation,
    updateAppellation,
    deleteAppellation,
    getAppellationTree
  };
}
